"use client";

import { PropsWithChildren } from "react";
import { ApiHealthBanner } from "./ApiHealthBanner";
import { useApiHealthStatus, API_HEALTH_STATUS } from "@/hooks/health";

/**
 * Wrapper component that shows a non-blocking warning banner when API health is degraded.
 *
 * Unlike the previous blocking approach, this wrapper:
 * - Always renders children (app continues to work)
 * - Shows a dismissible banner for health issues
 * - Does NOT show banner during silent reconnection (RECONNECTING state)
 */
export function ApiDownWrapper({ children }: PropsWithChildren) {
  const { status } = useApiHealthStatus();

  // Show banner for degraded states, but NOT for RECONNECTING (silent reconnect)
  const showBanner = status === API_HEALTH_STATUS.DOWN || status === API_HEALTH_STATUS.OFFLINE;

  return (
    <>
      {showBanner && <ApiHealthBanner status={status} />}
      {children}
    </>
  );
}
